<template>
  <ConfirmationModal
    cancelTestID="conditionalRemovalDialog-button-cancel"
    confirmColor="danger"
    confirmTestID="conditionalRemovalDialog-button-confirm"
    modalTestID="conditionalRemovalDialog-modal-removal"
    :confirmText="confirmText"
    :description="outcomeText"
    :maxWidth="460"
    :show="visible"
    :text="affectedText"
    :title="titleText"
    @cancel="handleCancel"
    @confirm="handleConfirm"
  />
</template>
<script>
import _ from 'lodash'

import ConfirmationModal from '@/components/Modals/ConfirmationModal.vue'

const createEmptyPayload = () => ({
  items: [],
  previousItems: null,
  affectedCount: 0,
  scoringType: undefined,
})

// The standalone removal dialog: the parent opens it with a payload and
// executes the emitted decision. Confirm carries { items, scoringType,
// shouldApply } — shouldApply is the empty-payload backstop. Cancel carries
// { previousItems, previousScoringType }. Both outcomes self-close the dialog.
export default {
  name: 'ConditionalRemovalDialog',

  components: {
    ConfirmationModal,
  },

  data() {
    return {
      visible: false,
      payload: createEmptyPayload(),
    }
  },

  computed: {
    shouldApply() {
      return !_.isEmpty(this.payload.items)
    },

    affectedCount() {
      return this.payload.affectedCount
    },

    titleText() {
      return this.$t('checklist.visibility_rule.conditional_removal_title')
    },

    affectedText() {
      return this.$t(
        'checklist.visibility_rule.conditional_removal_text_affected',
        { count: this.affectedCount }
      )
    },

    outcomeText() {
      return this.$t(
        'checklist.visibility_rule.conditional_removal_text_outcome',
        { count: this.affectedCount }
      )
    },

    confirmText() {
      return this.$t('checklist.visibility_rule.conditional_removal_confirm')
    },
  },

  methods: {
    open(payload = {}) {
      this.payload = { ...createEmptyPayload(), ...payload }
      this.visible = true
    },

    close() {
      this.visible = false
      this.payload = createEmptyPayload()
    },

    handleConfirm() {
      const { items, scoringType } = this.payload

      this.$emit('confirm', {
        items,
        scoringType,
        shouldApply: this.shouldApply,
      })
      this.close()
    },

    handleCancel() {
      this.$emit('cancel', {
        previousItems: this.payload.previousItems,
        previousScoringType: this.payload.previousScoringType,
      })
      this.close()
    },
  },
}
</script>
